/* eslint-disable no-nested-ternary */
import {inlineError} from '@s-ui/decorators'

import {DomainSharedError} from '../../../shared/Errors/DomainSharedError.js'
import MotorFetcherFactory from '../factory.js'
import Fetcher from '../Fetcher.js'

export class FetchOrFail extends Fetcher {
  static create({config}) {
    return new FetchOrFail({
      proxyFetcher: MotorFetcherFactory.proxyFetcher({config}),
      config
    })
  }

  constructor({proxyFetcher, config}) {
    super()
    this._proxyFetcher = proxyFetcher
    this._config = config
  }

  /**
   * @params Error hash {404: 404ErrorFactory, 401: 401ErrorFactory, GENERIC_ERROR: GenericErrorFactory, ...}
   * GENERIC_ERROR: GenericErrorFactory is compulsory
   */
  withErrorsFactories(errors = {}) {
    this._errors = errors
    return this
  }

  @inlineError
  async _try(fetch) {
    try {
      return await fetch()
    } catch (error) {
      const GENERIC = this._config.get('COMMON').ERRORS.GENERIC
      const {message, response} = error

      // If not exists means that withErrorsFactories not has been executed on repositories, so it is executed now to retrieve default _errors value.
      if (!this._errors) this.withErrorsFactories()

      let errorFactory =
        this._errors[GENERIC] || (() => DomainSharedError.createGenericError({config: this._config, cause: error}))

      //  If the response is an error throwed from fetch() function
      if (response) {
        errorFactory = this._errors[response.status] || errorFactory
      }
      return Promise.reject(errorFactory({message, response}))
    }
  }

  /**
   * @method
   * @return [error, response]
   */
  get(url, params, fetcherOptions) {
    return this._try(() => this._proxyFetcher.create({for: url, fetcherOptions}).get(url, params))
  }

  /**
   * @method
   * @return [error, response]
   */
  post(url, body, params, fetcherOptions) {
    return this._try(() => this._proxyFetcher.create({for: url, fetcherOptions}).post(url, body, params))
  }

  /**
   * @method
   * @return [error, response]
   */
  patch(url, body, params, fetcherOptions) {
    return this._try(() => this._proxyFetcher.create({for: url, fetcherOptions}).patch(url, body, params))
  }

  /**
   * @method
   * @return [error, response]
   */
  put(url, body, params, fetcherOptions) {
    return this._try(() => this._proxyFetcher.create({for: url, fetcherOptions}).put(url, body, params))
  }

  /**
   * @method
   * @return [error, response]
   */
  delete(url, params, fetcherOptions) {
    return this._try(() => this._proxyFetcher.create({for: url, fetcherOptions}).delete(url, params))
  }
}
